import { render, staticRenderFns } from "./OblykVideo.vue?vue&type=template&id=3ed7df7a"
import script from "./OblykVideo.vue?vue&type=script&lang=js"
export * from "./OblykVideo.vue?vue&type=script&lang=js"
import style0 from "./OblykVideo.vue?vue&type=style&index=0&id=3ed7df7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports